import { LegalPage } from "../components/LegalPage";

export default function Legal() {
  return <LegalPage i18nKey="legal" />;
}
